export default {
  inserted() {}
}
